// @flow
import apiConfig from '../../../../config'; // eslint-disable-line import/no-unresolved
import { RECEIVE_UPDATE_ACCOUNT_DETAILS, REQUEST_UPDATE_ACCOUNT_DETAILS } from '../../../ActionsConst';
import { showToast } from '../../../core/actions/toast/ToastActions';
import toastMsg from '../../../../data/toast';
import apiRequest from '../../../../stores/ApiService';
import AnalyticsClient from '../../../../clients/AnalyticsClient';
import accountEvents from '../../../../analytics/events/account';

export const requestUpdateAccountDetails = (companyName: string) => ({
  type: REQUEST_UPDATE_ACCOUNT_DETAILS,
  companyName,
});

export const receiveUpdateAccountDetails = (isSuccessful: boolean) => ({
  type: RECEIVE_UPDATE_ACCOUNT_DETAILS,
  isSuccessful,
});

export const showSuccessToast = () => {
  return showToast({
    id: Math.floor(Math.random() * 10000000),
    message: {
      messageDescriptor: toastMsg.updateAccountDetailsSuccessMessage,
    },
  });
};

export const showErrorToast = () => {
  return showToast({
    error: true,
    id: Math.floor(Math.random() * 10000000),
    message: {
      messageDescriptor: toastMsg.updateAccountDetailsErrorMessage,
    },
  });
};

const accountEndpointRequest = (baseApiUrl: string, companyName: string) => {
  return apiRequest({
    method: 'PUT',
    url: `${baseApiUrl}/${apiConfig.urls.accountConfiguration}`,
    body: { companyName },
  });
};

export const updateAccountDetails = (companyName: string) => {
  return (dispatch: Function, getState: Function, apiUrl: string) => {
    dispatch(requestUpdateAccountDetails(companyName));
    AnalyticsClient.trackEvent(accountEvents.updateAccountDetails());
    return accountEndpointRequest(apiUrl, companyName)
      .then((response) => {
        if (!response.ok) {
          dispatch(receiveUpdateAccountDetails(false));
          dispatch(showErrorToast());
          return;
        }

        dispatch(receiveUpdateAccountDetails(true));
        dispatch(showSuccessToast());
      })
      .catch(() => {
        dispatch(receiveUpdateAccountDetails(false));
        dispatch(showErrorToast());
      });
  };
};
